// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
    border: none;
    padding: 10px 40px;
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
    align-items: center;
    background: linear-gradient(
       90deg,
       rgba(40, 143, 67, 1) 0%,
       rgba(118, 185, 95, 1) 100%
    ) !important;
}
.button:hover{
    background: linear-gradient(
       90deg,
       rgb(35, 135, 62) 0%,
       rgb(104, 169, 83) 100%
    ) !important;
}

.button:disabled{
    opacity: 40%;
}

.mainWrapper>:nth-child(4) {
   display: flex;
   justify-content: center;
   margin-top: 30px !important;
}


.TransparentBtnWithBorder{
    border: 2px solid var(--Lime_Green);
    pointer-events: none;
}

.oranage-btn {
    border: none;
    padding: 8px 25px;
    border-radius: 4px;
    color: #fff;
    font-weight: 400;
    width: fit-content;
    align-items: center;
    background-color: var(--Support_Orange);
}

.oranage-btn-not-selected{
    background-color: #CDCFD3 !important; 
}

.oranage-btn:disabled{
    background-color: #CDCFD3;
}

.bulkUploadExSheetBtn{
    padding: 4px 10px;
    background-color: var(--Lime_Green);
    border: none;
    border-radius: 4px;
    font-weight: 600;
    color: #fff;
    position: relative;
}

.bulkUploadExSheetBtn:hover{
    background-color: #6bab55;
}

.bulk-dropdown-btn{
    position: absolute;
    top: 50px;
    z-index: 100;
    border-radius: 4px;
    font-size: 13px;
    width: fit-content;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.bulk-dropdown-btn > button{
    padding: 8px 10px;
    background-color: var(--Lime_Green);
    width: 100%;
    border: none;
    text-align: start;
    color: #fff;
    font-weight: 600;
    border-bottom: 1px solid #eeffe9;
}

.bulk-dropdown-btn > button:hover{
    background-color: #6bab55;
}`, "",{"version":3,"sources":["webpack://./src/commanComponents/buttons/buttons.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;;;;gBAIY;AAChB;AACA;IACI;;;;gBAIY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,2BAA2B;AAC9B;;;AAGA;IACI,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".button {\n    border: none;\n    padding: 10px 40px;\n    border-radius: 4px;\n    color: #fff;\n    font-weight: 600;\n    align-items: center;\n    background: linear-gradient(\n       90deg,\n       rgba(40, 143, 67, 1) 0%,\n       rgba(118, 185, 95, 1) 100%\n    ) !important;\n}\n.button:hover{\n    background: linear-gradient(\n       90deg,\n       rgb(35, 135, 62) 0%,\n       rgb(104, 169, 83) 100%\n    ) !important;\n}\n\n.button:disabled{\n    opacity: 40%;\n}\n\n.mainWrapper>:nth-child(4) {\n   display: flex;\n   justify-content: center;\n   margin-top: 30px !important;\n}\n\n\n.TransparentBtnWithBorder{\n    border: 2px solid var(--Lime_Green);\n    pointer-events: none;\n}\n\n.oranage-btn {\n    border: none;\n    padding: 8px 25px;\n    border-radius: 4px;\n    color: #fff;\n    font-weight: 400;\n    width: fit-content;\n    align-items: center;\n    background-color: var(--Support_Orange);\n}\n\n.oranage-btn-not-selected{\n    background-color: #CDCFD3 !important; \n}\n\n.oranage-btn:disabled{\n    background-color: #CDCFD3;\n}\n\n.bulkUploadExSheetBtn{\n    padding: 4px 10px;\n    background-color: var(--Lime_Green);\n    border: none;\n    border-radius: 4px;\n    font-weight: 600;\n    color: #fff;\n    position: relative;\n}\n\n.bulkUploadExSheetBtn:hover{\n    background-color: #6bab55;\n}\n\n.bulk-dropdown-btn{\n    position: absolute;\n    top: 50px;\n    z-index: 100;\n    border-radius: 4px;\n    font-size: 13px;\n    width: fit-content;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.bulk-dropdown-btn > button{\n    padding: 8px 10px;\n    background-color: var(--Lime_Green);\n    width: 100%;\n    border: none;\n    text-align: start;\n    color: #fff;\n    font-weight: 600;\n    border-bottom: 1px solid #eeffe9;\n}\n\n.bulk-dropdown-btn > button:hover{\n    background-color: #6bab55;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
